import React from 'react';
import ReactDOM from 'react-dom';
import Fsgo from "./FsgoComponent";
import {settings} from '../constants';

let renderFsgo = function(id) {
	let mountNode = document.getElementById(id);

	if (mountNode) {
		performance.mark(`fsgo[0]-render-start`);
		let title = mountNode.getAttribute('title');
		let regionalIds = mountNode.getAttribute('regional-ids');
		let postType = mountNode.getAttribute('post-type') || settings.SF_POST_TYPE;
		let videosItemSize = mountNode.getAttribute('videos-item-size') === '1';
		let isNationalOnly = mountNode.getAttribute('ino') === '1';
		let liveMaxCount = parseInt(mountNode.getAttribute('lmc')) || 0;
		let featuredMaxCount = parseInt(mountNode.getAttribute('fmc')) || 0;
		let sportId = parseInt(mountNode.getAttribute('sid')) || 0;
		let isFifaWC = mountNode.getAttribute('fifa-wc') === '1';
		ReactDOM.render(<Fsgo title={title}
							  regionalIds={regionalIds}
							  postType={postType}
							  videosItemSize={videosItemSize}
							  isNationalOnly={isNationalOnly}
							  liveMaxCount={liveMaxCount}
							  featuredMaxCount={featuredMaxCount}
							  sportId={sportId}
							  isFifaWC={isFifaWC}
							  componentId={0}/>, mountNode);
	}
}

let mountNodes = document.getElementsByTagName('Fsgo');

if (mountNodes) {
	for (let i = 0; i < mountNodes.length; i++){
		let mountNode = mountNodes[i];
		renderFsgo(mountNode.getAttribute('id'));
	}
}

window.renderFsgo = renderFsgo;
